import React, { useEffect, useState } from "react";
import API, { ADD_USER_FAKE, LIST_USER_FAKE } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";
import { Button, Input, message, Table, Pagination } from "antd";
import ModalCommon from "../../components/Modal";

const TEXT = {
  stt: "STT",
  username: "Tên đăng nhập",
};

const TURNS_MIN = 1;   // random ngầm
const TURNS_MAX = 100; // random ngầm

const PopupFakeUserManager = () => {
  const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);

  // form tạo mới
  const [username, setUsername] = useState("");

  // list & paging
  const [dataList, setDataList] = useState([]);
  const [page, setPage] = useState(1);
  const [totalRecord, setTotalRecord] = useState(0);
  const [loading, setLoading] = useState(false);

  // antd message
  const [messageApi, contextHolder] = message.useMessage();

  const locale = { emptyText: TEXT_DEF.text0035 };
  const showTotal = (total) => `Tổng cộng ${total} tài khoản`;
  const onChangePage = (p) => setPage(p);

  useEffect(() => {
    getListData();
  }, [page]);

  const showError = (msg) =>
    messageApi.open({ type: "error", content: msg || "Đã có lỗi xảy ra" });
  const showSuccess = (msg) =>
    messageApi.open({ type: "success", content: msg || "Thành công" });

  const randInt = (min, max) =>
    Math.floor(Math.random() * (max - min + 1)) + min;

  const getListData = async () => {
    try {
      setLoading(true);
      const resp = await API.get(`${LIST_USER_FAKE}?pageSize=10&page=${page}`);
      const res = resp?.data?.data?.data;
      if (res) {
        const dataCV = res.map((item, idx) => ({
          key: item?.id ?? idx,
          stt: item?.id,
          username: item?.username,
        }));
        setDataList(dataCV);
        setTotalRecord(resp?.data?.data?.total ?? 0);
      }
    } catch (error) {
      console.log(error);
      showError(error?.response?.data?.message || "Không tải được danh sách");
    } finally {
      setLoading(false);
    }
  };

  const onCreateUserFake = async () => {
    try {
      if (!username || !username.trim()) {
        showError("Vui lòng nhập tên đăng nhập");
        return;
      }
      const turns = randInt(TURNS_MIN, TURNS_MAX); // random ngầm
      const body = { username: username.trim(), turns };

      const response = await API.post(`${ADD_USER_FAKE}`, body);
      if (response?.data) {
        setIsShowModalSuccess(true);
        showSuccess(`Tạo tài khoản fake thành công!`);
        setUsername("");
        await getListData();
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "An error occurred";
      showError(errorMessage);
    }
  };

  const dataColums = [
    {
      title: TEXT.stt,
      key: "stt",
      dataIndex: "stt",
      align: "center",
      render: (_text, _record, index) =>
        (page - 1) * 10 + index + 1,
    },
    {
      title: TEXT_DEF.text0002,
      dataIndex: "username",
      key: "username",
      align: "center",
    },
  ];

  const renderInputUsername = () => (
    <div className="flex col-8 flex-row w-full items-center justify-center mt-2 gap-4">
      <div className="col-8 flex flex-col items-center justify-center">
        <div className="flex w-full items-center">
          <div className="flex w-[20%] justify-end mr-10">{TEXT.username}:</div>
          <div className="w-[60%]">
            <Input
              value={username}
              style={{ width: "100%" }}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Nhập tên đăng nhập"
            />
          </div>
        </div>
      </div>
      <div className="col-2 flex flex-col items-center mt-1">
        <Button type="primary" onClick={onCreateUserFake} disabled={!username?.trim()}>
          Lưu
        </Button>
      </div>
    </div>
  );

  const renderTableUser = () => (
    <div className="flex w-full items-center justify-center flex-col">
      <div style={{ display: "flex", width: "100%", marginTop: 20 }}>
        <Table
          key="table-user-fake"
          locale={locale}
          columns={dataColums}
          dataSource={dataList}
          loading={loading}
          pagination={false}
          bordered
          style={{ width: "100%" }}
        />
      </div>
      <div
        style={{
          display: "flex",
          width: "100%",
          marginTop: 15,
          justifyContent: "flex-end",
        }}
      >
        <Pagination
          current={page}
          total={totalRecord}
          onChange={onChangePage}
          defaultPageSize={10}
          showSizeChanger={false}
          showTotal={showTotal}
        />
      </div>
    </div>
  );

  return (
    <div className="col-12">
      {contextHolder}
      <div className="col-12">
        <div className="flex w-full">
          <div className="flex col-12 flex-col w-full items-center justify-center">
            {renderInputUsername()}
            <div style={{ fontWeight: 900, margin: 20 }}>
              --------------------------------------------
            </div>
            {renderTableUser()}
          </div>
        </div>
      </div>

      {isShowModalSuccess && (
        <ModalCommon
          isShow={isShowModalSuccess}
          message={"Tạo tài khoản fake thành công!"}
          txtBtnAcc={TEXT_DEF.text0007}
          actionNext={() => setIsShowModalSuccess(false)}
          close={() => setIsShowModalSuccess(false)}
        />
      )}
    </div>
  );
};

export default PopupFakeUserManager;
